import { createReducer, on } from '@ngrx/store';

import { CommercialState, ResponseStatus } from '@store';

import { CommercialActions } from './commercial.actions';
import { CommercialHelper } from './commercial.helpers';

const commercialInitialState: CommercialState = {
  fetchedInvitations: undefined,
  isFetchingInvitations: undefined,
  invitationsToSend: [],
  lastInvitationToSendIndex: 0,
  isCustomerInvitationPresent: false,
};

export const commercialReducer = createReducer(
  commercialInitialState,
  on(
    CommercialActions.fetchPartnerAccessList.attempt,
    (state): CommercialState => ({
      ...state,
      fetchedInvitations: undefined,
      isFetchingInvitations: true,
    })
  ),

  on(
    CommercialActions.fetchPartnerAccessList.success,
    (state, { invitations }): CommercialState => {
      return {
        ...state,
        fetchedInvitations: invitations,
        isFetchingInvitations: false,
        isCustomerInvitationPresent: CommercialHelper.checkCustomerInvitationPresent(
          state.invitationsToSend,
          invitations
        ),
      };
    }
  ),

  on(
    CommercialActions.fetchPartnerAccessList.error,
    (state): CommercialState => ({
      ...state,
      isFetchingInvitations: false,
    })
  ),

  on(
    CommercialActions.modifyPartnerAccessInvitations.add,
    (state, { invitation }): CommercialState => {
      const invitationsToSend = [...state.invitationsToSend, invitation];

      return {
        ...state,
        invitationsToSend,
        isCustomerInvitationPresent: CommercialHelper.checkCustomerInvitationPresent(
          invitationsToSend,
          state.fetchedInvitations
        ),
      };
    }
  ),

  on(
    CommercialActions.modifyPartnerAccessInvitations.remove,
    (state, { index }): CommercialState => {
      const invitationsToSend = state.invitationsToSend.filter(
        (_invitation, invitationIndex) => invitationIndex !== index
      );

      return {
        ...state,
        invitationsToSend,
        isCustomerInvitationPresent: CommercialHelper.checkCustomerInvitationPresent(
          invitationsToSend,
          state.fetchedInvitations
        ),
      };
    }
  ),

  on(
    CommercialActions.sendPartnerAccessInvitations.sendAll,
    (state): CommercialState => {
      const invitationsToSend = state.invitationsToSend.map((invitation) => {
        if (!invitation.responseStatus) {
          return { ...invitation, responseStatus: ResponseStatus.Loading };
        }

        return invitation;
      });

      return {
        ...state,
        invitationsToSend,
        isCustomerInvitationPresent: CommercialHelper.checkCustomerInvitationPresent(
          invitationsToSend,
          state.fetchedInvitations
        ),
      };
    }
  ),
  on(
    CommercialActions.sendPartnerAccessInvitations.sendOne,
    (state, { index }): CommercialState => {
      const invitationsToSend = [...state.invitationsToSend];
      invitationsToSend[index] = {
        ...invitationsToSend[index],
        responseStatus: ResponseStatus.Loading,
      };

      return {
        ...state,
        invitationsToSend,
      };
    }
  ),

  on(
    CommercialActions.modifyPartnerAccessInvitations.clear,
    (state): CommercialState => ({
      ...state,
      invitationsToSend: [],
      lastInvitationToSendIndex: 0,
    })
  ),

  on(
    CommercialActions.sendPartnerAccessInvitations.error,
    (state, { index }): CommercialState => {
      const invitationsToSend = [...state.invitationsToSend];
      invitationsToSend[index] = {
        ...invitationsToSend[index],
        responseStatus: ResponseStatus.Error,
      };

      return {
        ...state,
        invitationsToSend,
      };
    }
  ),

  on(
    CommercialActions.sendPartnerAccessInvitations.success,
    (state, { index }): CommercialState => {
      const invitationsToSend = [...state.invitationsToSend];
      invitationsToSend[index] = {
        ...invitationsToSend[index],
        responseStatus: ResponseStatus.Success,
      };

      return {
        ...state,
        invitationsToSend,
      };
    }
  ),

  on(
    CommercialActions.removePartnerAccessInvitation.success,
    (state, { token }): CommercialState => {
      const fetchedInvitations = state.fetchedInvitations.filter(
        (invitation) => invitation.token !== token
      );

      return {
        ...state,
        fetchedInvitations,
        isCustomerInvitationPresent: CommercialHelper.checkCustomerInvitationPresent(
          [],
          fetchedInvitations
        ),
      };
    }
  )
);
